// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleFilledSvg from "@fishx/icons-svg/es/asn/LeftCircleFilled";
import FishxIcon from '../components/FishxIcon';

var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleFilledSvg
  }));
};

LeftCircleFilled.displayName = 'LeftCircleFilled';
export default React.forwardRef(LeftCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftCircleFilled.js
// module id = 3022
// module chunks = 0